<template>
  <div class="image">
    <img :src="src" alt="" ref="image" />
  </div>
</template>

<script>
import gsap from "gsap";

export default {
  name: "LazyImage",
  props: { src: String },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    show() {
      gsap.set(this.$el, { clearProps: "all" });
      gsap.set(this.$refs.image, { clearProps: "all" });

      gsap.set(this.$el, { x: "-150%", overwrite: true });
      gsap.set(this.$refs.image, { x: "100%", overwrite: true });

      gsap.to(this.$el, {
        ease: "Expo.easeOut",
        x: 0,
        duration: 1.5,
        clearProps: "all",
      });

      gsap.to(this.$refs.image, {
        ease: "Expo.easeOut",
        duration: 1.5,
        x: 0,
        scale: 1,
        clearProps: "all",
      });
    },
  },
  mounted() {},
};
</script>

<style>
.image {
  overflow: hidden;
}
</style>
